var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-margin text-center p-2"},[_c('h3',[_vm._v(_vm._s(_vm.$t('errors.PAGE_NOT_FOUND')))])])}
var staticRenderFns = []

export { render, staticRenderFns }